import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';



// CSS Style
const useStyles = makeStyles((theme) => ({
    mainContainer: {
        background: "#233",
    },
    heading: {
        padding: '2rem 0',
        color: 'tomato',
        textTransform: 'uppercase',
        borderBottom: '2px dotted tan'
    },
    timeLine: {
        position: "relative",
        padding: '1rem',
        margin: '0 auto',
        zIndex: '88',
        "&:before": {
            content: "''",
            position: "absolute",
            height: '100%',
            border: '1px solid tan',
            right: '40px',
            top: '0',
            zIndex: -1

        },
        "&:after": {
            content: "''",
            display: "table",
            clear: 'both'
        },
        [theme.breakpoints.up("md")]: {
            padding: '2rem',
            "&:before": {
                left: 'calc(50% - 1px)',
                right: 'auto',
            }
        }

    },
    timelineItem: {
        padding: '1rem',
        borderBottom: '2px solid tan',
        position: 'relative',
        margin: '1rem 3rem 1rem 1rem',
        clear: 'both',
        "&:after": {
            content: "''",
            position: 'absolute',
        },
        "&:before": {
            content: "''",
            position: 'absolute',
            right: '-0.625rem',
            top: 'calc(50% - 5px)',
            borderStyle: 'solid',
            borderColor: 'tomato tomato transparent transparent',
            borderWidth: '0.625rem',
            transform: 'rotate(45deg)',

        },
        [theme.breakpoints.up("md")]: {
            width: '44%',
            margin: '1rem',
            "&:nth-of-type(2n)": {
                float: 'right',
                margin: '1rem',
                borderColor: 'tan',
                textAlign: 'right'

            },
            "&:nth-of-type(2n):before": {
                right: 'auto',
                left: '-.625rem',
                borderColor: 'transparent transparent tomato tomato'
            }
        }
    },
    timeLineYear: {
        textAlign: 'center!important',
        maxWidth: '11rem',
        margin: '0 3rem 0 auto',
        fontSize: '1.8rem',
        background: 'tomato',
        color: 'white',
        lineHeight: 1,
        padding: '.5rem 1rem',
        "&:before": {
            display: 'none'
        },
        [theme.breakpoints.up("md")]: {
            margin: '0 auto',
            "&:nth-of-type(2n)": {
                float: 'none',
                margin: '0 auto',
            },
            "&:nth-of-type(2n):before": {
                display: 'none'
            }
        }

    },

    title: {
        color: '#fff',
        padding: 0,
    },
    subTitle: {
        color: 'tomato'
    },
    bodyText: {
        color: 'tan'
    }


}));

const Resume = () => {
    const classes = useStyles();
    return (
        <>
            <Box component={"header"} className={classes.mainContainer}>
                <Typography variant="h4" className={classes.heading} align="center">
                    Education Qualification
               </Typography>
                <Box component={"div"} className={classes.timeLine}>
                    <Typography variant="h2" className={`${classes.timeLineYear} `}>
                        2018
                    </Typography>
                    <Box component={"div"} className={`${classes.timelineItem}`}>
                        <Typography variant="h5" className={`${classes.title}`} >
                            BSc. In Computer Science And Engineering
                        </Typography>
                        <Typography variant="body1" className={`${classes.subTitle}`}>
                            National University of Bangladesh
                        </Typography>
                        <Typography variant="subtitle1" className={`${classes.bodyText}`}>I have completed BSc. Degree in Computer Science and Engineering from Bangladesh Institute of Science and Technology under National University of Bangladesh.</Typography>

                    </Box>

                    <Typography variant="h2" className={`${classes.timeLineYear} ${classes.timelineItem}`}>
                        2012
                    </Typography>
                    <Box component={"div"} className={`${classes.timelineItem}`}>
                        <Typography variant="h5" className={`${classes.title}`} >Higher School Certificate</Typography>
                        <Typography variant="body1" className={`${classes.subTitle}`}>
                            Chowmuhani Govt. S.A College, Comilla Board
                        </Typography>
                        <Typography variant="subtitle1" className={`${classes.bodyText}`}>I have passed my Higher School Certificate from science background in 2012 from Chowmuhani Govt. S.A College.</Typography>

                    </Box>

                    <Typography variant="h2" className={`${classes.timeLineYear} ${classes.timelineItem}`}>
                        2010
                    </Typography>
                    <Box component={"div"} className={`${classes.timelineItem}`}>
                        <Typography variant="h5" className={`${classes.title}`} >Secondary School Certificate</Typography>
                        <Typography variant="body1" className={`${classes.subTitle}`}>
                            Tamuhani A.R.B High School, Comilla Board
                        </Typography>
                        <Typography variant="subtitle1" className={`${classes.bodyText}`}>I have passed my Secondary School Certificate from science background in 2010 from Comilla Board.</Typography>

                    </Box>


                </Box>
            </Box>

            {/* Working Exprience */}

            <Box component={"header"} className={classes.mainContainer}>
                <Typography variant="h4" className={classes.heading} align="center">
                    Working Exprience
               </Typography>
                <Box component={"div"} className={classes.timeLine}>
                    <Typography variant="h2" className={`${classes.timeLineYear} ${classes.timelineItem}`}>
                        2020
                    </Typography>
                    <Box component={"div"} className={`${classes.timelineItem}`}>
                        <Typography variant="h5" className={`${classes.title}`} >React Js Developer</Typography>
                        <Typography variant="body1" className={`${classes.subTitle}`}>Freelancer at Upwork</Typography>
                        <Typography variant="subtitle1" className={`${classes.bodyText}`}>I am an Experienced Front-End( React Js) web Developer with a demonstrated history of working in the Local Marketplace. Skilled in web design and Front-End Development using Modern JavaScript library like React Js, hooks, Redux. Strong engineering professional with a Computer Science and Engineer. For more details and projects see my profile and portfolio link.</Typography>

                    </Box>

                    <Typography variant="h2" className={`${classes.timeLineYear} ${classes.timelineItem}`}>
                        2018-2020
                    </Typography>
                    <Box component={"div"} className={`${classes.timelineItem}`}>
                        <Typography variant="h5" className={`${classes.title}`} >Web Designer</Typography>
                        <Typography variant="body1" className={`${classes.subTitle}`}>Freelancer</Typography>
                        <Typography variant="subtitle1" className={`${classes.bodyText}`}>I am a professional Front End developer base on modern JavaScript Library React, Redux specialist. In my professional career, I have done more than so many projects with different techniques, I have a strong grip on Bootstrap, Sass, Less, and css3.

                        If you want to convert your PSD, XD, Figma file into the responsive website you are at the right place and we can discuss the work and proceed.
                        </Typography>

                    </Box>

                    <Typography variant="h2" className={`${classes.timeLineYear} ${classes.timelineItem}`}>
                        2019-2020
                    </Typography>
                    <Box component={"div"} className={`${classes.timelineItem}`}>
                        <Typography variant="h5" className={`${classes.title}`} >Software Quality Assurance</Typography>
                        <Typography variant="body1" className={`${classes.subTitle}`}>Flora System Ltd.</Typography>
                        <Typography variant="subtitle1" className={`${classes.bodyText}`}>Currrently I an working a Software Company as a SQA. My Duties and Responsibility is Testing and Integration code for Banking type Software.</Typography>

                    </Box>

                    <Typography variant="h2" className={`${classes.timeLineYear} ${classes.timelineItem}`}>
                        2018
                    </Typography>
                    <Box component={"div"} className={`${classes.timelineItem}`}>
                        <Typography variant="h5" className={`${classes.title}`} >Jr. IOT Engineer</Typography>
                        <Typography variant="body1" className={`${classes.subTitle}`}>Mechatronical Garage</Typography>
                        <Typography variant="subtitle1" className={`${classes.bodyText}`}>I was an employee of the company Mechatronical Garage as a Jr.IOT Engineer. I was working On  Attendances Management System, Fire Safty Guard IoT device</Typography>

                    </Box>



                    

                </Box>
            </Box>
        </>
    );
};

export default Resume;